import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import components from '@/components'
import Vclipboard from '@/directives/Vclipboard'
import 'bootstrap/dist/css/bootstrap.min.css'



const app = createApp(App)

components.forEach(element => {
    app.component(element.name, element)
});
app.directive('clipboard', Vclipboard)

app.use(store).use(router).mount('#app')
